import React, { Component } from 'react';
import { CardLayout, TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Grid, TableHead, TableBody, Box, TableFooter, Button, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import SingleTemplate from '../containers/SingleTemplate';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class SingleResa extends Component {
    state = { }

    componentDidMount = () => {
        console.log("[INFO] MOUNTING SALE SINGLE ");

        const {shop} = this.props
        if(shop && shop.logo.filename && !shop.src){
            this.props.getPhoto(shop.id, shop.logo.filename)
        }
    }
    createProductList = () => {
        const { PRODUCTS, resa, shop } = this.props

        return resa.products.map( resaItem => {

            let prod = PRODUCTS[resaItem.product_id]
            let totalTTC = parseFloat(resaItem.price) // prix vendu TTC
            let totalHT = resaItem.totalHT || totalTTC / (1 + resaItem.prod_tva_rate / 100) // prix vendu HT
            let PUHT = totalHT / resaItem.quantity

            // let discount = Math.round(( 1 - resaItem.price / ( resaItem.priceR || prod.prix_venteHT * resaItem.quantity ) ) * 10000) / 100 // %
            // let discountAmount = ssTt - ssTtBase

            // if(ssTt > ssTtBase){
            //     ssTtBase = ssTt
            //     PUHT = resaItem.price / resaItem.quantity
            //     discount = 0
            //     discountAmount = 0
            // }
            
            // console.log("PRODUCT LIST discount", discount);
            return (
                <TableRow key={resaItem.id}>
                    <TableCell className="text-left">{prod.name}</TableCell>
                    <TableCell>{resaItem.quantity}</TableCell>
                </TableRow>
            )
        })
    }
    
    render(){
        console.log("[STATE] PRODUCT",this.props);
        const { shop, client, resa} = this.props;
        return(
            <SingleTemplate
                shop={shop}
                client={client}
                sale={resa}
                notif={this.props.notif}
            >
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell className="text-left">Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.createProductList()}
                        <TableRow>
                            <TableCell colSpan={2}></TableCell>
                        </TableRow>
                    </TableBody>                                
                </TableLayout>     
            </SingleTemplate>                    
        )
    }
}

export default SingleResa;